import {fetchNextApiCall, getCompetition, getCompetitionScorers} from 'app/services/api';
import {catchDataError, checkApiRedirect, RedirectException, parseLinkHeader} from 'app/helpers/apiHelpers';
import {checkCompetitionPathRedirect} from 'app/helpers/actionsHelpers';
import {changeHeaderText} from 'app/actions/headerActions';
import {updateHistory} from 'app/actions/historyActions';
import {updateHttpError} from 'app/components/error/ErrorHandlerActions';

function updateLeague(data) {
  return {
    type: 'LEAGUE_SCORERS_META_LEAGUE_UPDATE',
    data,
  };
}

function updateScorers(data) {
  return {
    type: 'LEAGUE_SCORERS_UPDATE',
    data,
  };
}

function errorScorers(data) {
  return {
    type: 'LEAGUE_SCORERS_ERROR',
    data,
  };
}

function fetchingScorers() {
  return {
    type: `LEAGUE_SCORERS_FETCHING`,
  };
}

function setLeagueHeader(dispatch, league, seasonSlug) {
  const competitionSeasonName = seasonSlug ? `${league.name} ${league.season.name}` : league.name;
  const parent = {
    name: competitionSeasonName,
    entity: 'league',
    slugs: {
      leagueSlug: league.slug,
      seasonSlug: seasonSlug,
    },
  };

  dispatch(
    changeHeaderText({
      title: 'Torjäger',
      parent,
    })
  );
}

function fetchLeagueScorers(leagueSlug, seasonSlug, dispatchRedux, reloading) {
  return function (dispatch, state) {
    let response1;
    if (!reloading) {
      if (state.metaLeague && state.scorers.length) {
        setLeagueHeader(dispatchRedux, state.metaLeague, seasonSlug);
        return;
      }
      if (state.error) {
        return;
      }

      response1 = getCompetition(leagueSlug, seasonSlug)
        .then(response => {
          const league = response.data;
          checkApiRedirect(league.slug, leagueSlug, league.season, seasonSlug, null, league.active);
          checkCompetitionPathRedirect(league?.category?.id);
          dispatch(updateLeague(league));
          setLeagueHeader(dispatchRedux, league, seasonSlug);
        })
        .catch(error => {
          if (error instanceof RedirectException) {
            throw error;
          } else {
            const errorData = catchDataError(error);
            dispatchRedux(updateHttpError(errorData));
          }
        });
    }

    const {isFetching, nextUrl} = state;
    if (isFetching || nextUrl === null) {
      return;
    }
    const fetchFunc = nextUrl ? fetchNextApiCall(nextUrl) : getCompetitionScorers(leagueSlug, seasonSlug);
    dispatch(fetchingScorers());
    const response2 = fetchFunc
      .then(response => {
        const meta = parseLinkHeader(response.headers.link);
        const nextUrl = meta.next ? meta.next : null;
        dispatch(updateScorers({scorers: response.data, nextUrl}));
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(errorScorers(errorData));
      });

    return Promise.all([response1, response2]);
  };
}

function fetchLeagueScorersSSR(leagueSlug, seasonSlug) {
  return function (dispatch, getState) {
    const response1 = getCompetition(leagueSlug, seasonSlug)
      .then(response => {
        const league = response.data;
        checkApiRedirect(league.slug, leagueSlug, league.season, seasonSlug, getState, league.active);
        checkCompetitionPathRedirect(league?.category?.id, getState);
        dispatch(updateHistory('undefined', {store: 'LeagueScorersPage', data: {metaLeague: response.data}}));
        setLeagueHeader(dispatch, league, seasonSlug);
      })
      .catch(error => {
        if (error instanceof RedirectException) {
          throw error;
        } else {
          const errorData = catchDataError(error);
          dispatch(updateHttpError(errorData));
        }
      });

    const response2 = getCompetitionScorers(leagueSlug, seasonSlug)
      .then(response => {
        const meta = parseLinkHeader(response.headers.link);
        const nextUrl = meta.next ? meta.next : null;
        dispatch(
          updateHistory('undefined', {
            store: 'LeagueScorersPage',
            data: {scorers: response.data, error: null, nextUrl, isFetching: false},
          })
        );
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(
          updateHistory('undefined', {
            store: 'LeagueScorersPage',
            data: {scorers: [], error: errorData, nextUrl: null, isFetching: false},
          })
        );
      });

    return Promise.all([response1, response2]);
  };
}

export {fetchLeagueScorersSSR, fetchLeagueScorers};
